import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { loginApi } from '@/app/login/api';
import { LoginFrame, LOGIN_INPUT, LOGIN_PRIMARY } from '@/app/login/LoginFrame';

/** 설정 메일의 링크(`/login/setup?token=…`)로 들어와 비밀번호를 정한다. 정책 검사는 서버가 한다. */
export function PasswordSetupView(): React.JSX.Element {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  if (!token) {
    return (
      <LoginFrame title="비밀번호 설정" hint="링크가 올바르지 않습니다">
        <p className="text-[12.5px] text-muted">메일의 링크를 그대로 열거나, 관리자에게 설정 메일을 다시 요청해 주세요.</p>
      </LoginFrame>
    );
  }

  if (done) {
    return (
      <LoginFrame title="비밀번호 설정" hint="설정을 마쳤습니다">
        <Link to="/login" className={`${LOGIN_PRIMARY} block text-center`}>
          로그인하러 가기
        </Link>
      </LoginFrame>
    );
  }

  const submit = (event: React.SubmitEvent<HTMLFormElement>): void => {
    event.preventDefault();
    if (password !== confirm) {
      setError('두 비밀번호가 다릅니다');
      return;
    }
    setBusy(true);
    setError(null);
    loginApi
      .completePasswordSetup(token, password)
      .then(() => setDone(true))
      .catch((cause: Error) => setError(cause.message.replace(/^요청 실패 \(HTTP \d+\) — /, '')))
      .finally(() => setBusy(false));
  };

  return (
    <LoginFrame title="비밀번호 설정" hint="10자 이상, 이메일과 다르게">
      <form onSubmit={submit} className="flex flex-col gap-2.5">
        <input
          type="password"
          autoComplete="new-password"
          required
          autoFocus
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          placeholder="새 비밀번호"
          className={LOGIN_INPUT}
        />
        <input
          type="password"
          autoComplete="new-password"
          required
          value={confirm}
          onChange={(event) => setConfirm(event.target.value)}
          placeholder="새 비밀번호 확인"
          className={LOGIN_INPUT}
        />
        {error && <p className="text-[12px] text-rose-700">{error}</p>}
        <button type="submit" disabled={busy} className={LOGIN_PRIMARY}>
          {busy ? '저장 중…' : '비밀번호 정하기'}
        </button>
      </form>
    </LoginFrame>
  );
}
